import React from "react";
import PropTypes from "prop-types";
import { PERIODS } from "constants/periods";
import { useTranslation } from "react-i18next";
import InputText from "shared/components/inputs/InputText";
import InputSelect from "shared/components/inputs/InputSelect";

const InputPhase = ({
    defaultValue,
    setTime,
    setTimes,
    labelTimes,
    labelTime,
    deadline,
    error,
    noMarginBottom,
    onBlur
}) => {

    const { t } = useTranslation();

    const periodMapping = PERIODS.map(({ value }) => {
        return {
            value,
            label: t(`period.${value}`)
        };
    });

    return (
        <div className="cols-m">
            <div className="col-sm">
                <InputText
                    noMarginBottom={noMarginBottom}
                    error={error}
                    small
                    type="number"
                    label={labelTimes || t("phase.time.amount")}
                    onChange={({ target }) => { setTimes(parseInt(target.value)); }}
                    defaultValue={defaultValue?.times || 1}
                    onBlur={onBlur}
                />
                {deadline && <span className="phase-deadline">{deadline}</span>}
            </div>
            <div className="col">
                <InputSelect
                    error={error}
                    items={periodMapping}
                    label={labelTime || t("phase.time.range")}
                    onChange={({ target }) => { setTime(target.value); }}
                    defaultValue={defaultValue?.time || "years"}
                    onClose={onBlur}
                />

            </div>
        </div>
    );
};

InputPhase.propTypes = {
    defaultValue: PropTypes.object,
    setTimes: PropTypes.func.isRequired,
    setTime: PropTypes.func.isRequired,
    labelTime: PropTypes.string,
    labelTimes: PropTypes.string,
    error: PropTypes.bool,
    deadline: PropTypes.string,
    noMarginBottom: PropTypes.bool,
    onBlur: PropTypes.func
};

export default InputPhase;